import {getEventTicketLimitPerOrder, hasPricingOptions} from '@wix/wix-events-commons-statics'
import {SEATING_ERROR} from '../../constants'
import {setPlaceDonationError, setPlaceDonationErrors, setSeatingError} from '../../reducers/seating/errors'
import {getEvent} from '../../selectors/event'
import {isInAccessibilityMode, isInDescription} from '../../selectors/seating/mode'
import {
  getPlaceQuantityById,
  isPlaceArea,
  isPlaceInBasket,
  isPlaceReservableAsWhole,
} from '../../selectors/seating/place'
import {getAnyPlaceById, getPlaces, getPlacesInBasket} from '../../selectors/seating/places'
import {getSelectedTicketsQuantity, isTicketLimitReached} from '../../selectors/selected-tickets'
import {checkDonationError} from '../../services/donations'
import {createAsyncAction} from '../../services/redux-toolkit'

export const validateDonation = createAsyncAction<
  boolean,
  {placeId: string; ticket: wix.events.ticketing.Ticket; donation: string}
>('VALIDATE_DONATION', async ({placeId, ticket, donation}, {dispatch}) => {
  const error = checkDonationError(ticket, donation)

  if (error) {
    dispatch(setPlaceDonationError({placeId, error}))
  }

  return !error
})

export const validateAllDonations = createAsyncAction<boolean, void>(
  'VALIDATE_ALL_DONATIONS',
  async (_, {getState, dispatch}) => {
    const state = getState()
    const placesInBasket = getPlacesInBasket(state)

    const errors = placesInBasket
      .map(place => {
        const error = checkDonationError(place.ticket, place.donation)
        if (error) {
          return {placeId: place.id, error}
        }
        return undefined
      })
      .filter(Boolean)

    dispatch(setPlaceDonationErrors(errors))

    return !errors.length
  },
)

export const validateTicketLimit = createAsyncAction<boolean, {planPlaceId: string}>(
  'VALIDATE_TICKET_LIMIT',
  async ({planPlaceId}, {dispatch, getState}) => {
    const state = getState()

    const place = getAnyPlaceById(getPlaces(state), planPlaceId)
    const placeQuantity = getPlaceQuantityById(getPlaces(state), place.id)
    const placeInBasket = isPlaceInBasket(place)
    const area = isPlaceArea(place)
    const pricingOptions = hasPricingOptions(place.ticket)
    const showAccessibilityMode = isInAccessibilityMode(state)
    const inDescription = isInDescription(state)

    const accountForAreaCounterValue = !placeInBasket && area

    const selectedTicketsQuantity = getSelectedTicketsQuantity(state)
    const ticketLimitReached = isTicketLimitReached(state, accountForAreaCounterValue, place.id)
    const event = getEvent(state)
    const eventTicketLimitPerOrder = getEventTicketLimitPerOrder(event)

    const wholeElementLimitReachedError =
      !placeInBasket &&
      isPlaceReservableAsWhole(place) &&
      placeQuantity === 0 &&
      eventTicketLimitPerOrder < selectedTicketsQuantity + place.places.length

    const canShowError = placeInBasket && area && pricingOptions && !showAccessibilityMode && !inDescription

    const ticketLimitReachedError = ticketLimitReached && (!placeInBasket || canShowError)

    if (wholeElementLimitReachedError || ticketLimitReachedError) {
      dispatch(setSeatingError({error: SEATING_ERROR.TICKET_LIMIT_REACHED}))
      return false
    }
    return true
  },
)
